






















































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import draggable from "vuedraggable";
import { ILocale } from "@/@types/locale";

@Component({
  components: { draggable },
})
export default class CinemaStaffForm extends Vue {
  @Prop({ type: Array, default: () => [] }) staff!: Array<ILocale>;
  @Prop({ type: String, default: "" }) parent!: string;
  @Prop({ type: String, default: "" }) locale!: string;

  enabled = true;
  dragging = false;

  text = "";
  texts: ILocale = {};

  get languages(): Array<string> {
    return this.$store.getters.getLanguages;
  }

  activeLocale = this.locale;

  @Watch("activeLocale")
  routerLocalesName(): void {
    if (this.texts)
      this.text = this.texts[this.activeLocale]
        ? this.texts[this.activeLocale]
        : "";
    else this.text = "";
  }

  @Watch("text")
  entryFilmName(): void {
    this.texts[this.activeLocale] = this.text;
  }

  updateTextList(): void {
    this.$emit("addNewStaffPersone", this.texts);
    this.texts = {};
    this.text = "";
  }
}
